import { MenuItem, OrderMealEntree, OrderMealEntreeContents } from '@/models';

export interface MealService {
  findItemInEntree(item: MenuItem, entree: OrderMealEntree): OrderMealEntreeContents | undefined;
}

export class AppMealService implements MealService {
  findItemInEntree(item: MenuItem, entree: OrderMealEntree) {
    if (!entree.contents) {
      return undefined;
    }

    return entree.contents.find(i => i.menuItemId == item.itemId);
  }
}
